var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3744 6.6385L15.707 3.26391L14.4348 0.6875H7.56563L6.29307 3.26391L9.62607 6.6385C6.24598 7.29163 3.68195 10.3005 3.68195 13.9078C3.68195 17.9912 6.9651 21.3125 11 21.3125C15.035 21.3125 18.3181 17.9912 18.3181 13.9078C18.3181 10.3005 15.7541 7.29128 12.3744 6.6385ZM11.4748 5.04453H10.5198L10.0207 3.53134H11.9735L11.4748 5.04453ZM14.0213 1.353L14.7686 2.86619H12.7167L12.4703 1.353H14.0213ZM12.6744 3.53134H14.508L13.0127 5.04453H12.1757L12.6744 3.53134ZM10.2032 1.353H11.7962L12.0426 2.86619H9.95263L10.2032 1.353ZM7.97882 1.353H9.52913L9.27854 2.86619H7.23151L7.97882 1.353ZM7.49104 3.53134H9.32013L9.81891 5.04453H8.9812L7.49104 3.53134ZM11 20.647C7.33154 20.647 4.3471 17.6237 4.3471 13.9078C4.3471 10.1918 7.33188 7.16822 11 7.16822C14.6682 7.16822 17.6526 10.1915 17.6526 13.9078C17.6526 17.6241 14.6685 20.647 11 20.647Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.94336C7.74919 7.94336 5.10403 10.6191 5.10403 13.9078C5.10403 17.1968 7.74919 19.8725 11 19.8725C14.2509 19.8725 16.896 17.1971 16.896 13.9078C16.896 10.6191 14.2509 7.94336 11 7.94336ZM11 19.207C8.11563 19.207 5.76919 16.8296 5.76919 13.9078C5.76919 10.9859 8.11597 8.60852 11 8.60852C13.8841 8.60852 16.2305 10.9859 16.2305 13.9078C16.2305 16.8296 13.8844 19.207 11 19.207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.76600122b7c92ad431abab7b9da468d6.svg";
export { ForwardRef as ReactComponent };